var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.196,
    height: 15.12,
    viewBox: "0 0 14.196 15.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7803",
    "data-name": "Path 7803",
    d: "M186.808,25.563c-.046-.267-.085-.492-.123-.717a.849.849,0,0,1,.69-1.02.831.831,0,0,1,.96.718q.256,1.431.5,2.867a.841.841,0,0,1-.724,1.012l-2.869.491a.839.839,0,0,1-.989-.68.829.829,0,0,1,.663-.963c.35-.074.7-.126,1.058-.189l.019-.068c-.411-.159-.813-.355-1.235-.471a6.035,6.035,0,0,0-1.491-.2,5.382,5.382,0,0,0-5.366,4.833,5.461,5.461,0,0,0,10.816,1.5.829.829,0,0,1,.959-.762.842.842,0,0,1,.7,1.047,6.926,6.926,0,0,1-1.865,3.746,7.973,7.973,0,0,1-1.892,1.44,6.771,6.771,0,0,1-3.585.781,7.133,7.133,0,0,1-1.533-14.021,7.014,7.014,0,0,1,5.119.558Z",
    transform: "translate(-176.19 -23.813)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reloadIcon.39d8ccd87ebe4d53cc3ba69bdf43a12d.svg";
export { ForwardRef as ReactComponent };